import { SET_FATAL_ERROR } from './actionTypes';

export const setFatalError = fatalError => ({
    type: SET_FATAL_ERROR,
    payload: fatalError,
});
